import '@splidejs/splide/css';
import Splide from '@splidejs/splide';

class Gallery {
    constructor() {
        this.galleries = document.querySelectorAll('.acf-gallery');
        if (!this.galleries.length) return false;

        this.galleries.forEach((gallery) => {
            Gallery.init(gallery);
        });
    }

    static init(gallery) {
        const popup = gallery.querySelector('.acf-gallery__popup');
        const opener = document.getElementById(`open-${popup.getAttribute('data-popup')}`);
        let mounted = false;

        opener.addEventListener('click', () => {
            if (mounted) return;
            Gallery.mount(popup);
            mounted = true;
        });
    }

    static mount(popup) {
        const elem = popup.querySelector('.splide');

        if (elem) {
            const splide = new Splide(elem, {
                pagination: false,
                arrow: true,
                perPage: 1,
                perMove: 1,
                gap: '15rem',
                focus: 'center',
                trimSpace: false,
                type: 'loop',
                fixedWidth: '266px',
                fixedHeight: '400px',
                breakpoints: {
                    640: {
                        fixedHeight: '250px',
                        fixedWidth: '150px',
                        gap: '5rem',
                    },
                },
            });

            splide.mount();

            splide.on('move', (e) => {
                const currents = elem.querySelectorAll('.is-active');
                currents.forEach((current) => {
                    current.classList.remove('is-active');
                });

                ['prev', 'next'].forEach((side) => {
                    const slide = elem.querySelector(
                        `.is-${side}[aria-label="${e + 1} of ${splide.length}"]`,
                    );

                    if (slide) {
                        slide.classList.remove('is-next', 'is-prev');
                        slide.classList.add('is-active');
                    }
                });
            });
        }
    }
}

export default Gallery;
